import { render, staticRenderFns } from "./ModalVideoV2.vue?vue&type=template&id=66fb4092&"
import script from "./ModalVideoV2.vue?vue&type=script&lang=js&"
export * from "./ModalVideoV2.vue?vue&type=script&lang=js&"
import style0 from "./ModalVideoV2.vue?vue&type=style&index=0&id=66fb4092&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports